import { useState } from "react";
import ReactMarkdown from "react-markdown";

export default function ArticleUpload() {
  const [title, setTitle] = useState("");
  const [slug, setSlug] = useState("");
  const [category, setCategory] = useState("Education");
  const [excerpt, setExcerpt] = useState("");
  const [keywords, setKeywords] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [heroImage, setHeroImage] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [markdown, setMarkdown] = useState("");
  const [images, setImages] = useState([]);

  const generateSlug = (title) =>
    title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

  const handleTitleChange = (e) => {
    const val = e.target.value;
    setTitle(val);
    setSlug(generateSlug(val));
  };

  const handleImageChange = (e) => {
    setImages(Array.from(e.target.files));
  };

  const handlePublish = async () => {
    if (!slug || !markdown || !title) return alert("Missing required fields.");

    const blob = new Blob([markdown], { type: "text/markdown" });
    const file = new File([blob], `${slug}.md`, { type: "text/markdown" });

    const formData = new FormData();
    formData.append("slug", slug);
    formData.append("title", title);
    formData.append("excerpt", excerpt);
    formData.append("category", category);
    formData.append("thumbnail", thumbnail);
    formData.append("heroImage", heroImage);
    formData.append("metaTitle", metaTitle);
    formData.append("metaDescription", metaDescription);
    formData.append("keywords", JSON.stringify(keywords.split(",").map(k => k.trim())));
    formData.append("markdown", file);

    images.forEach(img => formData.append("images", img));

    const token = localStorage.getItem("adminAccessToken");

    const res = await fetch("/api/admin/article-upload", {
    method: "POST",
    body: formData,
    headers: {
        Authorization: `Bearer ${token}`,
    },
    });

    if (res.ok) {
      alert("✅ Article published successfully!");
    } else {
      alert("❌ Upload failed");
    }
  };

  return (
    <div className="p-6 max-w-screen-xl mx-auto">
      <h1 className="text-3xl font-bold mb-4">Article Upload</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block font-medium">Title</label>
          <input className="w-full border p-2 mb-2" value={title} onChange={handleTitleChange} />

          <label className="block font-medium">Slug</label>
          <input className="w-full border p-2 mb-2" value={slug} onChange={(e) => setSlug(e.target.value)} />

          <label className="block font-medium">Category</label>
          <select className="w-full border p-2 mb-2" value={category} onChange={(e) => setCategory(e.target.value)}>
            <option>Education</option>
            <option>News</option>
            <option>Market Analytics</option>
          </select>

          <label className="block font-medium">Excerpt</label>
          <textarea className="w-full border p-2 mb-2" rows={2} value={excerpt} onChange={(e) => setExcerpt(e.target.value)} />

          <label className="block font-medium">Keywords (comma-separated)</label>
          <input className="w-full border p-2 mb-2" value={keywords} onChange={(e) => setKeywords(e.target.value)} />

          <label className="block font-medium">Meta Title</label>
          <input className="w-full border p-2 mb-2" value={metaTitle} onChange={(e) => setMetaTitle(e.target.value)} />

          <label className="block font-medium">Meta Description</label>
          <textarea className="w-full border p-2 mb-4" rows={2} value={metaDescription} onChange={(e) => setMetaDescription(e.target.value)} />

          <label className="block font-medium">Image Reference Instruction</label>
          <div className="text-sm text-gray-600 border border-dashed border-gray-400 p-3 rounded mb-4 bg-gray-50">
            To insert uploaded images in your markdown, use:<br />
            <code className="block mt-2">
              ![Alt text](/images/blog/<strong>{slug || "your-slug"}</strong>/your-image-name.png)
            </code>
            <br />
            Example:<br />
            <code className="block">
              ![Top 10 Crypto Coins](/images/blog/top10cryptocurrencies/top10cryptocurrencies1.png)
            </code>
          </div>

          <label className="block font-medium">Upload Article Images</label>
          <input type="file" className="w-full border p-2 mb-4" multiple onChange={handleImageChange} />

          <button className="bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700" onClick={handlePublish}>
            Publish Article
          </button>
        </div>

        <div>
          <label className="block font-medium">Markdown Content</label>
          <textarea className="w-full border p-2 mb-2 h-60" value={markdown} onChange={(e) => setMarkdown(e.target.value)} />

          <label className="block font-medium mt-4">Live Preview</label>
          <div className="p-4 border bg-white overflow-auto prose">
            <ReactMarkdown>{markdown}</ReactMarkdown>
          </div>
        </div>
      </div>
    </div>
  );
}
